document.querySelectorAll('.listing-filters form select').forEach((select) => {
  select.addEventListener('change', () => {
    select.form.submit();
  });
});

const dropdowns = Array.from(document.querySelectorAll('[data-filter-dropdown]'));

const closeDropdown = (dropdown) => {
  dropdown.classList.remove('__open');
};

dropdowns.forEach((dropdown) => {
  const trigger = dropdown.querySelector('[data-filter-trigger]');
  const value = dropdown.querySelector('[data-filter-value]');
  const input = dropdown.querySelector('[data-filter-input]');
  const options = dropdown.querySelectorAll('[data-filter-option]');

  if (!trigger || !value || !input || !options.length) {
    return;
  }

  trigger.addEventListener('click', () => {
    const isOpen = dropdown.classList.contains('__open');
    dropdowns.forEach((item) => closeDropdown(item));
    if (!isOpen) {
      dropdown.classList.add('__open');
    }
  });

  options.forEach((option) => {
    option.addEventListener('click', () => {
      input.value = option.dataset.value || '';
      value.textContent = option.textContent.trim();
      closeDropdown(dropdown);

      // If no active filters, go back to the form's action URL
      const activeFilters = Array.from(
        input.form.querySelectorAll('[data-filter-input]')
      ).filter(
        (filterInput) =>
          filterInput.value !== '' && filterInput.value !== '0'
      );

      if (activeFilters.length === 0) {
        window.location.href = input.form.action;
        return;
      }

      // If we have 1 filter, redirect to the tax term URL from its data-link attr
      if (activeFilters.length === 1) {
        const activeFilter = activeFilters[0];
        const activeOption = activeFilter
          .closest('[data-filter-dropdown]')
          ?.querySelector(
            `[data-filter-option][data-value="${activeFilter.value}"]`
          );

        if (activeOption?.dataset.termLink) {
          window.location.href = activeOption.dataset.termLink;
          return;
        }
      }

      // Don't re-submit if we have no selection
      if (input.value === '' || input.value === '0') {
        return;
      }

      input.form.submit();
    });
  });
});

document.addEventListener('click', (event) => {
  dropdowns.forEach((dropdown) => {
    if (!dropdown.contains(event.target)) {
      closeDropdown(dropdown);
    }
  });
});
